import React from 'react'
import './products.css'

import { useNavigate } from 'react-router-dom'
import { motion } from "framer-motion"
import OneProduct from './OneProduct'

import pluginAurora from '../assets/AuroraSalePic4.png'
import pluginRefract from '../assets/RefractPromoImg3.jpg'
import pluginDuck from '../assets/DuckProduct2.jpg'

import { logEvent } from 'firebase/analytics'
import { analytics } from '../firebase'

const Productsinfo = () => {
    const navigate = useNavigate()

    const productData = [
        {
            id: 'aurora',
            name: 'Aurora',
            description: 'Advanced intelligent reverb. Leverage machine-learned spatial algorithms to generate lush, three-dimensional acoustic spaces without cluttering your mix.',
            originalPrice: '49.99',
            price: '29.99',
            img: pluginAurora,
            action: () => {
                logEvent(analytics, "Products_Aurora");
                navigate('/aurora');
            }
        },
        {
            id: 'refract',
            name: 'Refract',
            description: 'A revolutionary multiband processor. Add any VST3 or AU plugin to a specific frequency band, effectively turning every plugin in your arsenal into a multi-band powerhouse.',
            originalPrice: '49.99',
            price: '29.99',
            img: pluginRefract,
            action: () => {
                logEvent(analytics, "Products_Refract");
                navigate('/refract');
            }
        },
        {
            id: 'duck',
            name: 'Duck',
            description: 'Duck is a plugin host that can host all your favorite reverb, delays and effects plugins and makes it simple to duck the effect to the input signal, perfect for creating space while having large reverbs, or making space inbetween delays to reduce automation or time spent side chain routing. It is the fastest way to achieve this effect.',
            originalPrice: '29.99',
            price: '19.99',
            img: pluginDuck,
            action: () => {
                logEvent(analytics, "Products_Duck");
                navigate('/duck');
            }
        }
    ];

    return (
        <div className="products-page-wrapper">
            <div className="products__container">
                {/* Everything Bundle Hero */}
                <motion.div 
                    className="products__card bundle-hero-card"
                    initial={{ opacity: 0, y: 30 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6 }}
                    onClick={() => {
                        logEvent(analytics, "Products_EverythingBundle");
                        navigate('/checkout', { 
                            state: { 
                                products: [
                                    { id: 1, name: "Aurora", price: 29.99, originalPrice: 49.99, img: pluginAurora },
                                    { id: 2, name: "Refract", price: 29.99, originalPrice: 49.99, img: pluginRefract },
                                    { id: 3, name: "Duck", price: 19.99, originalPrice: 29.99, img: pluginDuck }
                                ]
                            } 
                        });
                    }}
                >
                    <div className="products__card-left" style={{ flex: '1 1 40%' }}>
                        <div className="bundle-collage">
                            <img src={pluginAurora} alt="Aurora" className="bundle-img-aurora" />
                            <img src={pluginDuck} alt="Duck" className="bundle-img-duck" />
                            <img src={pluginRefract} alt="Refract" className="bundle-img-refract" />
                        </div>
                    </div>
                    <div className="products__card-center" style={{ flex: '1 1 40%' }}>
                        <h2 className="products__card-title bundle-hero-title">Everything Bundle</h2>
                        <p className="products__card-description" style={{ color: '#fff', fontSize: '1.05rem' }}>
                            Get the ultimate Tape Signal experience. Includes <strong>Refract</strong>, <strong>Aurora</strong>, and <strong>Duck</strong>. Transform your mixing workflow with the complete state-of-the-art suite at a massive discount.
                        </p>
                    </div>
                    <div className="products__card-right">
                        <div className="products__card-price-original">
                            $129.99
                        </div>
                        <div className="products__card-price" style={{ color: '#4bdcc6' }}>
                            $54.99
                        </div>
                        <button className="products__card-button bundle-hero-buybtn">
                            Buy Bundle
                        </button>
                    </div>
                </motion.div>

                {productData.map((prod) => (
                    <OneProduct
                        key={prod.id}
                        name={prod.name}
                        description={prod.description}
                        originalPrice={prod.originalPrice}
                        price={prod.price}
                        img={prod.img}
                        navigateAction={prod.action}
                    />
                ))}
            </div>
        </div>
    )
}

export default Productsinfo